import { classes } from 'utils/style';
import styles from './List.module.css';

export const List = ({ ordered, children, className, ...rest }) => {
  const Element = ordered ? 'ol' : 'ul';

  return (
    <Element className={classes(styles.list, className)} {...rest}>
      {children}
    </Element>
  );
};

export const ListItem = ({ children, className, ...rest }) => {
  return (
    <li className={classes(styles.item, className)} {...rest}>
      {children}
    </li>
  );
};
